import React from 'react';
import { motion } from 'framer-motion';
import { ArrowDownIcon } from 'lucide-react';
export function HowItWorks() {
  const steps = [{
    num: '1',
    title: 'Descarga el Protocolo',
    desc: 'Obtén acceso inmediato al PDF en cualquier dispositivo.'
  }, {
    num: '2',
    title: 'Aplica los 120 segundos',
    desc: 'Sigue la acción específica asignada para cada día.'
  }, {
    num: '3',
    title: 'Observa la Apertura',
    desc: 'Mira cómo el muro de silencio comienza a agrietarse a medida que recuperas la confianza de tu hijo.'
  }];
  return <section className="bg-cream py-16 md:py-24 px-4" data-id="element-54">
      <div className="max-w-4xl mx-auto" data-id="element-55">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-56">
          <h2 className="font-heading text-3xl md:text-4xl text-navy font-bold mb-16" data-id="element-57">
            Cómo funciona
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-58">
            {/* Connecting line for desktop */}
            <div className="hidden md:block absolute top-10 left-1/6 right-1/6 h-0.5 bg-amber/30 -z-10" data-id="element-59"></div>

            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.2
          }} className="flex flex-col items-center" data-id="element-60">
                <div className="w-20 h-20 rounded-full bg-navy text-amber flex items-center justify-center font-heading text-3xl font-bold mb-6 shadow-lg border-4 border-cream" data-id="element-61">
                  {step.num}
                </div>
                <h3 className="font-heading text-xl font-bold text-navy mb-3" data-id="element-62">
                  {step.title}
                </h3>
                <p className="font-body text-charcoal text-center" data-id="element-63">
                  {step.desc}
                </p>

                {index < steps.length - 1 && <ArrowDownIcon className="w-8 h-8 text-amber/50 mt-6 md:hidden" data-id="element-64" />}
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}